import React from 'react';

interface TourParagraphProps {
    title: string;
    text: string[];
}

function TourParagraph({ title, text }: TourParagraphProps) {
    return (
        <div>
            <h2 className="tourTitle">{title}</h2>
            {text.length > 0 && (
                <div className="introText">
                    {text.map((textBlock, index) => (
                        <p key={index} className="homeTextBlock">{textBlock}</p>
                    ))}
                </div>
            )}
        </div>
    );
}

export default TourParagraph;
